/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Jaw_Physio_TermsInputs */

const en_service_type_jaw_physio_terms = /** @type {(inputs: Service_Type_Jaw_Physio_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jaw, tmj, bruxism, teeth grinding, jaw pain`)
};

const pl_service_type_jaw_physio_terms = /** @type {(inputs: Service_Type_Jaw_Physio_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`staw skroniowo żuchwowy, szczęka, żuchwa, bruksizm, zgrzytanie zębami, ból szczęki, tmj`)
};

/**
* | output |
* | --- |
* | "jaw, tmj, bruxism, teeth grinding, jaw pain" |
*
* @param {Service_Type_Jaw_Physio_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_jaw_physio_terms = /** @type {((inputs?: Service_Type_Jaw_Physio_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Jaw_Physio_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_jaw_physio_terms(inputs)
	return en_service_type_jaw_physio_terms(inputs)
});